import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_foreign_migrant_supervisors'

export const dataPointDefinition = {
  retracedId: 'number_foreign_migrant_supervisors',
  name: 'Number of foreign migrant supervisors:',
  description:
    'Foreign migrants are persons who moved from their home country for work in another country, i.e., persons whose home country is not the country where the facility is located. ',
  meta: {
    slcpMeta: {
      key: 'fp-wor-29',
      number: 'FP-WOR-40',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-wor-29', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29030,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
